import React, { memo, useEffect } from 'react';
import { WhiteLabelStore } from '@plug/redux/store';
import AffiliateSignUp from '../../pages/sign-up/pages/affiliate-registration';
import useLocalStorage from '@plug/hooks/use-local-storage';

interface Props {
  email?: string;
  organizationName?: string;
  incompleteFlow?: boolean;
}

const AffiliateRegistrationEntryPoint: React.FC<Props> = props => {
  const { set } = useLocalStorage();

  useEffect(() => {
    set('isNewUser', 'true');
  }, [set]);

  return <AffiliateSignUp {...props} />;
};

export default memo(AffiliateRegistrationEntryPoint);
